"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_boost_1 = __importDefault(require("apollo-boost"));
const CenterStockManagement_1 = __importDefault(require("../ui/CenterStockManagement"));
const centerAssertManagement_1 = __importDefault(require("./centerAssertManagement"));
const StockManagementAdmin_1 = __importDefault(require("../ui/StockManagementAdmin"));
const mergeConfig = require('coact/config/mergeConfig');
function installClient(fullConfig) {
    const client = new apollo_boost_1.default({ uri: 'api/route/centerStockManagement' });
    const centerAssertManagementPath = '/centerAssertManagement';
    return mergeConfig(fullConfig, {
        routes: {
            stockManagementAdmin: {
                title: '庫存設定 (管理中心)',
                path: '/stockManagementAdmin/',
                component: () => StockManagementAdmin_1.default({ client }),
            },
            centerStockManagement: {
                title: '庫存查詢 (管理中心)',
                path: '/centerStockManagement/',
                component: () => CenterStockManagement_1.default({
                    path: '/centerStockManagement',
                    client,
                }),
            },
            centerAssertManagement: {
                title: '庫存盤點 (管理中心)',
                path: `${centerAssertManagementPath}/`,
                component: () => centerAssertManagement_1.default({
                    path: centerAssertManagementPath,
                    client,
                }),
            },
        },
    });
}
exports.default = installClient;
